import { z } from 'zod'

export const themeSchema = z.enum(['light', 'dark'])

export type ThemeName = z.infer<typeof themeSchema>
